<template>
  <div class="ui-table-info">
    <slot></slot>
  </div>
</template>

<script setup lang="ts"></script>

<style lang="scss">
@import '../styles/config';

.ui-table-info {
  font-family: $font-barlow;
  font-size: 0.875rem;

  @include media-breakpoint-up(md) {
    font-size: 1rem;
  }
}
</style>
